export default __webpack_public_path__ + "8d17b1db2b6a6ab9192805d77082d658.png";